import {z} from 'zod'
import {CookieConsentType} from 'types/CookieConsentType'
import {Language} from 'types/Language'
import {SidebarTheme} from 'types/SidebarTheme'
import {Theme} from 'types/Theme'

export enum CookieStorageKey {
  UI_LANGUAGE = 'rnw_ui_language',
  UI_THEME = 'rnw_ui_theme',
  UI_SIDEBAR_THEME = 'rnw_ui_sidebar_theme',
  COOKIE_CONSENT = 'CookieConsent',
}

/**
 * The following is a map of the cookie storage keys to their validation schemas
 */
export const cookiesSchemas = {
  [CookieStorageKey.UI_SIDEBAR_THEME]: z
    .enum(SidebarTheme)
    .default(SidebarTheme.LIGHT),
  [CookieStorageKey.UI_THEME]: z.enum(Theme).default(Theme.AUTO),
  [CookieStorageKey.UI_LANGUAGE]: z.enum(Language).default(Language.EN),
  [CookieStorageKey.COOKIE_CONSENT]: z
    .array(z.enum(CookieConsentType))
    .optional()
    .default(undefined),
} satisfies Record<CookieStorageKey, z.ZodSchema>
